// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const cpf: CountryValidator<"BR"> = createValidator(
  "br.cpf",
  27,
);

export default cpf;
export const compact = cpf.compact;
export const format = cpf.format;
export const validate = cpf.validate;
export const generate = (): string =>
  cpf.generate?.() ??
  (() => {
    throw new Error(
      "Validator br.cpf cannot generate values",
    );
  })();
